import React from 'react';
import imgResolver from '../utils/img-resolver';

import connectToStores from 'alt/utils/connectToStores';

import ShiftStore from '../stores/ShiftStore';
import checkOverflow from "../utils/checkModalOverflow";

@connectToStores
class PostUpdateModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            updatePosted: false,
            message: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isVisible !== nextProps.isVisible) {
            checkOverflow(nextProps.isVisible);
        }
    }

    static getPropsFromStores() {
        return {
            sStore: ShiftStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore];
    }

    render() {
        let classes = "modal-overlay post-update-modal-overlay";
        if (this.props.isVisible) classes += " active";

        return (
            <div onClick={this.toggleModal.bind(this)} className={classes}>
                <div onClick={this.modalClick.bind(this)} className="modal whitebox">
                    <header className="modal-header">
                        <h1>Send an update</h1>
                        <button className="close" onClick={this.toggleModal.bind(this)}><span>&times;</span></button>
                    </header>

                    {(this.state.updatePosted ? this.renderDone() : this.renderForm())}
                </div>
            </div>
        );
    }

    renderForm() {
        const shift = this.props.shift;

        return (
            <div className="modal-content modal-content-form">
                <div className="description">
                    <h3>How does this work?</h3>
                    <p>An update is sent to all hired candidates’ email addresses who you have not declined. If you change the shift details but do not send an update, the hires will not know the shift has changed.</p>
                </div>

                <div className="message">
                    <div className="label-title">Message</div>
                    <textarea ref="messageBox" rows="6" onChange={this.textChange.bind(this)} className="post-modal-editor"/>
                </div>

                <div className="buttons">
                    <button className="btn btn-green btn-small" onClick={this.sendUpdate.bind(this, shift)}>Send now</button>
                    <button className="btn-transparent" onClick={this.toggleModal.bind(this)}>Cancel</button>
                </div>
            </div>
        );
    }

    textChange(e) {
        this.setState({message: e.target.value});
    }

    sendUpdate(shift) {
        const message = this.state.message.replace(/<\/?[^>]+(>|$)/g, "");
        ShiftStore.postUpdateToCandidates(shift.id, message);

        if (!this.props.sStore.postUpdateTocandidatesError) {
            this.setState({
                updatePosted: true
            });
        }
    }

    renderDone() {
        return (
            <div className="modal-content modal-content-sent">
                <div className="sent-msg">
                    <img className="modal-sent-img" src={require('../styles/images/icon_update_sent.svg')} alt="" />
                    <h1>Done! Update sent to {this.props.candidates.length} people!</h1>
                    <button className="btn btn-bordered btn-small btn-close" onClick={this.toggleModal.bind(this)}>Close</button>
                </div>
            </div>
        );
    }

    modalClick(evt) {
        evt.stopPropagation();
    }

    toggleModal() {
        this.setState({updatePosted: false});
        this.props.toggleModal();
    }
}

export default PostUpdateModal;



/** WEBPACK FOOTER **
 ** ./app/src/components/PostUpdateModal.js
 **/